module.exports = __webpack_public_path__ + "img/send.bc34524b.svg";